<script setup lang="ts">
import { useForwardPropsEmits } from "reka-ui";
import type { InputHTMLAttributes } from "vue";
import { useDelegatedProps, type ClassProps } from "../../lib/base-props";
import FormField, { type FormFieldProps } from "../form/FormField.vue";
import Switch, { type SwitchEmits, type SwitchProps } from "./Switch.vue";

defineOptions({ inheritAttrs: true });

interface Props
	extends ClassProps,
		SwitchProps,
		FormFieldProps,
		/* @vue-ignore */ Omit<InputHTMLAttributes, keyof SwitchProps | keyof FormFieldProps> {}

const props = withDefaults(defineProps<Props>(), { color: "primary" });
const emit = defineEmits<SwitchEmits>();

const delegatedProps = useDelegatedProps(props);
const forwarded = useForwardPropsEmits(delegatedProps, emit);
</script>

<template>
	<FormField
		:class="props.class"
		:label="props.label"
		labelPosition="left"
		:hint="props.hint"
		:errors="props.errors"
	>
		<Switch v-bind="{ ...forwarded, ...$attrs }" />
	</FormField>
</template>
